(() => {
  if (window.CaffreyCedarShape) { window.CaffreyCedarShape.refresh(); return; }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const scenes = new Map();
  let frame = null;

  function callouts(scene, amount, stage, photo) {
    const point = (x, y) => {
      const screenX = mobile.matches ? photo.right - y * photo.width : photo.left + x * photo.width;
      const screenY = mobile.matches ? photo.top + x * photo.height : photo.top + y * photo.height;
      return [(screenX - stage.left) / stage.width * 1000, (screenY - stage.top) / stage.height * 1000];
    };
    const ends = {
      toe: mobile.matches ? point(.12, .475) : point(.31, .58),
      tubes: point(.56 - .027 * amount, .405),
      heel: point(.83 - .054 * amount, .64)
    };
    scene.markers.forEach(({ part, note, line, dot }) => {
      const label = note.getBoundingClientRect();
      let start, bend;
      if (mobile.matches) {
        const heading = note.querySelector('h3').getBoundingClientRect();
        start = [(label.left - stage.left - 12) / stage.width * 1000, (heading.top + heading.height / 2 - stage.top) / stage.height * 1000];
        bend = [start[0] - 35, start[1]];
      } else {
        start = [(label.left + label.width / 2 - stage.left) / stage.width * 1000, (part === 'tubes' ? label.bottom - stage.top + 12 : label.top - stage.top - 12) / stage.height * 1000];
        bend = [start[0], start[1] + (part === 'tubes' ? 35 : -35)];
      }
      const end = ends[part];
      line.setAttribute('points', [start, bend, end].map(p => p.map(v => v.toFixed(2)).join(',')).join(' '));
      dot.setAttribute('cx', end[0]); dot.setAttribute('cy', end[1]);
      dot.setAttribute('rx', 3.2 / stage.width * 1000); dot.setAttribute('ry', 3.2 / stage.height * 1000);
    });
    scene.svg.removeAttribute('hidden');
  }

  function render(now) {
    frame = null;
    if (document.hidden) return;
    let playing = false;
    scenes.forEach(scene => {
      const stage = scene.stage.getBoundingClientRect();
      if (!stage.width || !stage.height) return;
      const visible = stage.top < innerHeight * .55 && stage.bottom > innerHeight * .45;
      const ready = scene.photo.querySelector('img').complete;
      let amount = 0;
      let state = reduced.matches ? 'reduced' : 'outside';
      if (!visible || reduced.matches) {
        scene.started = null;
        scene.played = false;
      } else if (ready) {
        if (!scene.played) {
          if (scene.started === null) scene.started = now;
          const progress = Math.min(1, (now - scene.started) / 3200);
          amount = Math.sin(progress * Math.PI) ** 2;
          scene.played = progress === 1;
          if (scene.played) amount = 0;
          playing = playing || !scene.played;
        }
        state = scene.played ? 'complete' : 'playing';
      } else state = 'waiting';
      scene.host.dataset.ctMotionState = state;
      const key = [amount.toFixed(4), stage.width, stage.height, mobile.matches].join(':');
      if (scene.key === key) return;
      const photo = scene.photo.getBoundingClientRect();
      scene.host.style.setProperty('--ct-compress', amount.toFixed(4));
      callouts(scene, amount, stage, photo);
      scene.key = key;
    });
    if (playing) schedule();
  }
  function schedule() { if (frame === null && !document.hidden) frame = requestAnimationFrame(render); }
  function refresh() {
    scenes.forEach((scene, host) => { if (!host.isConnected) scenes.delete(host); });
    document.querySelectorAll('[data-ct-mechanism]').forEach(host => {
      scenes.set(host, {
        host, stage: host.querySelector('.cf-ct-workbench'), photo: host.querySelector('.cf-ct-motion-photo'), svg: host.querySelector('[data-ct-callouts]'), key: null, started: null, played: false,
        markers: [...host.querySelectorAll('[data-ct-marker]')].map(group => ({ part: group.dataset.ctMarker, note: host.querySelector(`[data-ct-part="${group.dataset.ctMarker}"]`), line: group.querySelector('polyline'), dot: group.querySelector('ellipse') }))
      });
      host.dataset.ctShapeReady = 'true';
    });
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', refresh);
  document.addEventListener('visibilitychange', () => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null;
    scenes.forEach(scene => { scene.started = null; scene.played = false; });
    schedule();
  });
  document.addEventListener('load', event => { if (event.target.matches?.('.cf-ct-motion-front')) schedule(); }, true);
  reduced.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
  document.addEventListener('shopify:section:reorder', refresh);
  window.CaffreyCedarShape = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
})();
